// extracted by mini-css-extract-plugin
export default {"hero-block":"HeroBlock_hero-block__d3MB-","hero-block__container":"HeroBlock_hero-block__container__Z3PQ8"};